import moment from 'moment-timezone'

/// @param dayOfWeek [0 - 6, Mo - Fri]
export const getDayOfWeek = (dayOfWeek: number) =>
  moment.tz(moment.tz.guess()).startOf('isoWeek').add(dayOfWeek, 'days').format('ddd')
